import styled from 'styled-components';
import { Colors, FontFamily, FontSize, FontWeight, LineHeight } from 'web-common/src/shared/styles';

interface AnchorProps {
  fontFamily?: FontFamily;
  size?: FontSize;
  color?: Colors;
  lineHeight?: LineHeight;
  fontWeight?: FontWeight;
}

/**
 * @deprecated The shef-web design system is being retired. web-common has no
 *   counterpart yet — see the migration ticket before adding a new call site.
 * @see https://app.asana.com/0/0/1218340650878851
 */
export const Anchor = styled.a<AnchorProps>`
  color: ${({ color = Colors.RADISH }) => color};
  font-family: ${({ fontFamily = FontFamily.SANS }) => fontFamily};
  font-size: ${({ size = 'inherit' }) => size};
  line-height: ${({ lineHeight = 'inherit' }) => lineHeight};
`;
